// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_7916a6f"};